import { render, staticRenderFns } from "./UserAdminTab.vue?vue&type=template&id=06730f10&scoped=true&"
import script from "./UserAdminTab.vue?vue&type=script&lang=js&"
export * from "./UserAdminTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06730f10",
  null
  
)

export default component.exports